import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import {
  getLotExpirations,
  getLotsForExpandedItem,
} from "@redotech/redo-fulfillment-common/lot/line-item-lots";
import { formatLotExpiration } from "@redotech/redo-fulfillment-common/lot/lot-expiration";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export function getLotExpirationDateCell(row: FulfillmentGroupData): string {
  return getLotExpirations(row.items ?? []).join(", ");
}

export function getLotExpirationDateUnitCell(
  row: FulfillmentGroupData,
  expansionIndex: number,
): string {
  return getLotsForExpandedItem(getExpandedItems(row), expansionIndex)
    .map(({ lot }) => formatLotExpiration(lot.expirationDate) ?? "")
    .join(", ");
}

export const LotExpirationDateCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Lot expiration date",
    cell: getLotExpirationDateCell,
    expandedCsvCell: getLotExpirationDateUnitCell,
  };
